import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { CheckCircle, Shield } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
export function FinalCTA() {
  return <section id="precio" className="py-24 bg-[#faf8f5] relative overflow-hidden" data-id="element-24">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-5" data-id="element-25"></div>
      <div className="absolute -top-24 -right-24 w-96 h-96 bg-[#c9a227]/10 rounded-full blur-3xl" data-id="element-26"></div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-27">
        <div className="max-w-4xl mx-auto bg-white rounded-3xl shadow-2xl overflow-hidden border border-gray-100" data-id="element-28">
          <div className="grid grid-cols-1 md:grid-cols-2" data-id="element-29">
            <div className="p-10 md:p-12 flex flex-col justify-center" data-id="element-30">
              <h2 className="text-3xl md:text-4xl font-serif font-bold text-[#1a4d3e] mb-6" data-id="element-31">
                ¿Lista para sentirte ligera otra vez?
              </h2>
              <p className="text-gray-600 mb-8 text-lg" data-id="element-32">
                Imagina despertar en 3 semanas con la piel radiante, sin
                inflamación y con la energía de hace 10 años. Este no es un
                libro más; es la llave a tu libertad metabólica.
              </p>

              <div className="space-y-4 mb-8" data-id="element-33">
                <div className="flex items-center text-gray-700" data-id="element-34">
                  <CheckCircle className="text-[#c9a227] mr-3" size={20} data-id="element-35" />
                  <span data-id="element-36">Plan de alimentación hormonal</span>
                </div>
                <div className="flex items-center text-gray-700" data-id="element-37">
                  <CheckCircle className="text-[#c9a227] mr-3" size={20} data-id="element-38" />
                  <span data-id="element-39">Guía de suplementación natural</span>
                </div>
                <div className="flex items-center text-gray-700" data-id="element-40">
                  <CheckCircle className="text-[#c9a227] mr-3" size={20} data-id="element-41" />
                  <span data-id="element-42">Acceso de por vida al protocolo</span>
                </div>
              </div>

              <Button size="lg" withArrow bounce href="https://ecoterr4.com/cart/44441705480271:1" className="w-full md:w-auto shadow-xl shadow-[#c9a227]/20" data-id="element-43">
                ¡QUIERO MI METABO-RESET AHORA!
              </Button>

              <div className="mt-6 flex items-center justify-center md:justify-start text-xs text-gray-500" data-id="element-44">
                <Shield size={14} className="mr-1" data-id="element-45" />
                <span data-id="element-46">Pago 100% Seguro y Encriptado</span>
              </div>
            </div>

            <div className="bg-[#1a4d3e] p-10 md:p-12 text-white flex flex-col justify-center items-center text-center relative overflow-hidden" data-id="element-47">
              <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/stardust.png')] opacity-20" data-id="element-48"></div>

              <h3 className="text-2xl font-serif font-bold mb-2 relative z-10" data-id="element-49">
                Oferta Especial
              </h3>
              <div className="text-5xl font-bold text-[#c9a227] mb-2 relative z-10" data-id="element-50">
                $10 USD
              </div>
              <p className="text-gray-300 line-through mb-4 relative z-10" data-id="element-51">
                Precio Regular: $97 USD
              </p>

              <div className="mb-6 relative z-10" data-id="element-52">
                <CountdownTimer hours={1} minutes={47} seconds={33} className="!bg-white/10 !border-white/20" data-id="element-53" />
              </div>

              <div className="bg-white/10 backdrop-blur-sm p-6 rounded-xl border border-white/20 relative z-10" data-id="element-54">
                <p className="text-sm mb-4" data-id="element-55">
                  "La mejor inversión que he hecho en mi salud. Vale cada
                  centavo por cómo me siento ahora."
                </p>
                <div className="flex justify-center text-[#c9a227]" data-id="element-56">
                  {[...Array(5)].map((_, i) => <StarIcon key={i} data-id="element-57" />)}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-12 text-center" data-id="element-58">
          <p className="text-gray-500 text-sm max-w-2xl mx-auto" data-id="element-59">
            Descargo de responsabilidad: Los resultados pueden variar de una
            persona a otra. Este producto no sustituye el consejo médico
            profesional.
          </p>
        </div>
      </div>
    </section>;
}
function StarIcon() {
  return <svg className="w-4 h-4 fill-current" viewBox="0 0 20 20" data-id="element-60">
      <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-61" />
    </svg>;
}